import { Outlet } from 'react-router-dom'
import { Sidebar } from './sidebar'
import { Topbar } from './topbar'
import { useUIStore } from '@/stores/ui-store'
import { cn } from '@/lib/utils'
import { useTenant } from '@/hooks/use-tenant'

export function Shell() {
  // Always hydrate currentTenant from the database on every authenticated session.
  // This prevents stale localStorage values from causing RLS failures in mutations.
  useTenant()

  const sidebarOpen = useUIStore((s) => s.sidebarOpen)

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      <div
        className={cn(
          'flex flex-1 flex-col overflow-hidden transition-all duration-300',
          sidebarOpen ? 'ml-64' : 'ml-16'
        )}
      >
        <Topbar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
